import { FETCH_WL_SUBSCRIPTIONS, UPDATE_WL_SUBSCRIPTIONS } from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'
import { API_CALL_REQUEST, API_CALL_FAILURE, API_CALL_SUCCESS } from 'actions/actionConstants'

export const initialWLSubscriptionState: App.WLSubscriptionsState = {
  settings: {
    experiencesFrequency: '',
    travelFrequency: '',
  },
  fetching: false,
  updating: false,
  fetchError: '',
  updateError: '',
}

const apiCalls = apiReducerSwitch<App.WLSubscriptionsState>({
  [FETCH_WL_SUBSCRIPTIONS]: {
    request: () => ({
      fetching: true,
      fetchError: '',
      updateError: '',
    }),
    success: (state, action) => ({
      ...state,
      settings: action.data,
      fetching: false,
      fetchError: '',
    }),
    failure: (state, action) => ({
      ...state,
      fetching: false,
      fetchError: action.error,
    }),
  },
  [UPDATE_WL_SUBSCRIPTIONS]: {
    request: () => ({
      updating: true,
      fetchError: '',
      updateError: '',
    }),
    success: (state, action) => ({
      ...state,
      settings: action.data,
      updating: false,
      updateError: '',
    }),
    failure: (state, action) => ({
      ...state,
      updating: false,
      updateError: action.error,
    }),
  },
})

export default createAppReducer<App.WLSubscriptionsState>(initialWLSubscriptionState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
})
